import { UniversalSearchInstrument } from "./types/instruments/search"

/**
 * Extracts the primary identifier and name from a UniversalSearchInstrument
 * for analytics and display purposes. Prioritizes human-readable aliases.
 *
 * @param searchInstrument - The search result instrument
 * @returns Object containing the instrument ID (alias when available) and name
 */
export function getSearchInstrumentIdAndName(searchInstrument: UniversalSearchInstrument): {
  id: string
  name: string
} {
  let id: string
  const name = searchInstrument.name

  switch (searchInstrument.type) {
    case "portfolio":
    case "index":
      // Use alias for human-readable analytics tracking
      id = searchInstrument.alias
      break
    case "benchmark":
    case "experiment":
      // These don't have aliases, use ID
      id = searchInstrument.id
      break
    case "security":
      // Use ticker for swaps and ETFs (human-readable)
      id = searchInstrument.ticker
      break
    default:
      // Exhaustiveness check: TypeScript will error if new types are added but not handled
      searchInstrument satisfies never
      // Defensive fallback for runtime safety
      id = "id" in searchInstrument ? (searchInstrument as { id: string }).id : ""
      break
  }

  return { id, name }
}
